import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ConseilsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-conseils',
  templateUrl: 'conseils.html',
})
export class ConseilsPage {
  
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConseilsPage');
  }

  goBack(){
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/conseils/conseils.ts